import React, { useEffect, useState } from "react";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

import VerTipoEstados from "./VerTipoEstados";
import EditarTipoEstado from "./EditarTipoEstado";
import FiltroTipoEstados from "./FiltroTipoEstados";
import CrearTipoEstado from "./CrearTipoEstado";
import EliminarTipoEstado from "./EliminarTipoEstado";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
// IMPORTANTE: Importamos DynamicTable
import DynamicTable from "../../../components/listing/DynamicTable";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListarTipoEstados() {
  const [showVer, setShowVer] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const [showFiltro, setShowFiltro] = useState(false);
  const [showCrear, setShowCrear] = useState(false);
  const [showEliminar, setShowEliminar] = useState(false);

  const [tipoEstadoId, setTipoEstadoId] = useState(null);
  const [registroAEliminar, setRegistroAEliminar] = useState(null);

  const [filters, setFilters] = useState({ q: "" });

  // === PAGINACIÓN REAL DEL BACK ===
  const [page, setPage] = useState(0); // backend usa 0-based
  const [size, setSize] = useState(10);

  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);

  const [loading, setLoading] = useState(false);

  // === Cargar datos desde backend ===
  const loadData = async () => {
    setLoading(true);
    try {
      const url = apiRoutes.estadoTipo.listUrl({
        page,
        size,
        q: filters.q,
      });

      const json = await appFetchJson(url);

      setData(json.items ?? []);
      setTotalElements(json.totalElements ?? 0);
    } catch (err) {
      console.error("Error cargando Tipos de Estado:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [page, size, filters]);

  // ====================================================================
  // DEFINICIÓN DE COLUMNAS (TOTAL 100%)
  // ====================================================================
  const columns = [
    // 1. TIPO DE ESTADO (85%)
    { 
      header: "Tipo de estado", 
      accessor: "nombre",
      type: "text", 
      width: "85%", 
      cellClass: "font-medium text-gray-800 break-words" 
    },
    // 2. ACCIÓN (15%)
    {
      header: "Acción",
      type: "action", 
      width: "15%",
      render: (e) => (
        <div className="flex justify-center items-center gap-2">
          <button
            onClick={() => {
              setTipoEstadoId(e.id);
              setShowEditar(true);
            }}
            className="text-gray-500 hover:text-blue-600 p-1"
            title="Editar"
          >
            <FaEdit />
          </button>

          <button
            onClick={() => {
              setRegistroAEliminar(e);
              setShowEliminar(true);
            }}
            className="text-gray-500 hover:text-red-600 p-1"
            title="Eliminar"
          >
            <FaTrashAlt />
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="page">

      <ListHeader
        title="Tipos de Estado"
        onFilterClick={() => setShowFiltro(true)}
        filters={filters}
        onClearFilters={() => {
          setFilters({ q: "" });
          setPage(0);
        }}
        showAdd
        addLabel="Agregar"
        onAddClick={() => setShowCrear(true)}
        pageSize={size}
        onPageSizeChange={(newSize) => {
          setSize(newSize);
          setPage(0);
        }}
      />

      {loading && <div className="text-gray-600 mt-4 text-center">Cargando...</div>}

      {/* === TABLA DINÁMICA === */}
      {!loading && (
        <DynamicTable 
          size="S" // 2 Columnas -> Breakpoint 768px
          data={data}
          columns={columns}
        />
      )}

      <ListFooter
        page={page + 1} // 👈 ListFooter es 1-based
        pageSize={size}
        total={totalElements}
        onPageChange={(p) => setPage(p - 1)} // 👈 back a 0-based
      />

      {/* === MODALES === */}

      {showVer && (
        <VerTipoEstados id={tipoEstadoId} onClose={() => setShowVer(false)} />
      )}

      {showEditar && (
        <EditarTipoEstado
          id={tipoEstadoId}
          onVolver={() => setShowEditar(false)}
          onSaved={() => {
            loadData();
            setShowEditar(false);
          }}
        />
      )}

      {showFiltro && (
        <FiltroTipoEstados
          initialFilters={filters}
          onSubmit={(f) => {
            setFilters(f);
            setPage(0);
          }}
          onClose={() => setShowFiltro(false)}
        />
      )}

      {showCrear && (
        <CrearTipoEstado
          onCreated={() => {
            loadData();
            setShowCrear(false);
          }}
          onClose={() => setShowCrear(false)}
        />
      )}

      {/* Modal Eliminar */}
      {showEliminar && (
        <div className="modal-backdrop" onClick={() => setShowEliminar(false)}>
          <div
            className="modal-panel-lg no-x"
            onClick={(e) => e.stopPropagation()}
          >
            <EliminarTipoEstado
              registro={registroAEliminar}
              onClose={() => setShowEliminar(false)}
              onDeleted={() => {
                loadData();
                setShowEliminar(false);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}